import React, { useLayoutEffect } from 'react';
import styled from 'styled-components';
import anime from 'animejs';
import { getAssetsUrl } from 'utilities';

const SpidersImage = styled.img`
  position: absolute;
  top: 0;
  left: 10%;
  max-width: 250px;
  min-width: 100px;
  width: 30%;
`;

const Bat1Image = styled.img`
  position: absolute;
  top: 0;
  right: 20%;
  max-width: 250px;
  min-width: 100px;
  width: 20%;
`;

const Bat2Image = styled.img`
  position: absolute;
  top: 0;
  right: 10%;
  max-width: 220px;
  min-width: 70px;
  width: 15%;
`;

export default function AnimatedFrames() {
  useLayoutEffect(() => {
    // Spiders
    anime({
      targets: '#background-spiders',
      translateY: [-400, -40],
      easing: 'easeOutElastic',
      duration: 4000,
      delay: 2000,
      complete: () => {
        anime({
          targets: '#background-spiders',
          translateY: [-40, -45],
          easing: 'easeInOutSine',
          duration: 1000,
          direction: 'alternate',
          loop: true,
        });
      },
    });

    // Bat 1
    anime({
      targets: '#background-bat1',
      translateY: [100, 105],
      easing: 'easeInOutSine',
      duration: 1000,
      direction: 'alternate',
      loop: true,
    });

    // Bat 2
    anime({
      targets: '#background-bat2',
      translateY: [180, 185],
      easing: 'easeInOutSine',
      duration: 2000,
      delay: 400,
      direction: 'alternate',
      loop: true,
    });
  }, []);

  return (
    <>
      <SpidersImage
        id="background-spiders"
        src={getAssetsUrl('landing/spiders.png')}
      />
      <Bat1Image id="background-bat1" src={getAssetsUrl('landing/bat1.png')} />
      <Bat2Image id="background-bat2" src={getAssetsUrl('landing/bat2.png')} />
    </>
  );
}
